import * as React from 'react';
import { Visibility } from "@mui/icons-material";
import TrapFocus from '@mui/material/Unstable_TrapFocus';
import { useLocation, useNavigate } from "react-router-dom";
import {
    Alert,
    Avatar, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
    Fade, FormControl, FormControlLabel, FormLabel, Grid, IconButton, InputAdornment, InputLabel, List, ListItem, ListItemAvatar, ListItemIcon, ListItemText, MenuItem, Paper, Popover, Radio, RadioGroup, Select, Snackbar, Stack, Switch, TextField, Tooltip, Typography
} from "@mui/material";
import Service from '../../../../util/Service';

const listTipo = [
    "String",
    "Date",
    "DateTime",
    "Json"
];

export default function APIPageDialog(props) {
    const { onClose, refDiv, open,         
        element, onSelect,
        closePai, refreshEditor } = props;
    const navigate = useNavigate();
    const location = useLocation();
    const [bannerOpen, setBannerOpen] = React.useState(false);
    const [jsonTxt, setJsonTxt] = React.useState('');
    const [urlApi, setUrlApi] = React.useState();
    const [interno, setInterno] = React.useState(false);
    const [nome, setNome] = React.useState('');
    const [apiLocal, setApiLocal] = React.useState([]);
    const [headerTabel, setheaderTabel] = React.useState([]);
    const [caminho, setCaminho] = React.useState();
    const [page, setPage] = React.useState('table');
    const [uri, setURI] = React.useState('');
    const [clonedContent, setClonedContent] = React.useState(null);

    const [msg, setMsg] = React.useState();
    const [openSnack, setOpenSnack] = React.useState(false);

    const [value, setValue] = React.useState('sem');
    const handleChange = (event) => {
        setValue(event.target.value);
    };

    const handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setMsg();
        setOpenSnack(false);
    };

    const closeBanner = () => {
        setBannerOpen(false);
    };

    const handleClose = () => {
        onClose();
        closePai();
    };

    const geraPagina = () => {
        const remove = document.createElement('p');
        remove.setAttribute("id", "paraRemover");
        remove.textContent = "---";

        if( clonedContent){
            clonedContent.replaceWith(remove);
        }else{
            refDiv.current.append( remove );
        }
        //clonedContent.replaceWith(remove);

        const el = document.getElementById("very2Editor");
        let html = '';
        const htmlOld = refDiv.current.innerHTML;
        if (!el) {
            html = refDiv.current.innerHTML;
        } else {
            html = el.innerHTML;
        }

        var localUrl = urlApi;
        if( urlApi.includes('${')){
            let pos = urlApi.indexOf('${');
            let pos2 = urlApi.indexOf('}');
            const parm = urlApi.substring(pos+2, pos2);
            const userChoice = prompt("Indique o valor da variavel "+parm+": ");
            localUrl = urlApi.substring(0, pos)+userChoice;
        }

        const dado = {
            urlApi: localUrl,
            interno: interno,
            nome: nome,
            header: headerTabel,
            caminho: caminho,
            code: html,
            tpPagina: page,
            paginacao: value
        }

        Service.POST("/api/security/model/pageFromApi", dado).then(r => {
            console.log(r);
            if (r.success) {
                refDiv.current.innerHTML = r.dado;
                onClose();
                closePai();
                refreshEditor();
            } else {
                // alert(r.msg);
                setMsg(r.msg);
                setOpenSnack(true);
                refDiv.current.innerHTML = htmlOld;
            }

        })
    };
    const onChangeLocalApi = (e) => {
        if (e.target.checked) {
            Service.GET("/api/bpmn/buscaTodosAtivos").then(r => {
                if (r && r.length > 0) {
                    let list = [];
                    for (let x in r) {
                        const bpm = r[x];
                        list.push({
                            nome: bpm.nome,
                            value: "/api/bpmn/onLine/" + bpm.nome
                        })
                    }
                    setApiLocal(list);
                    console.log("onChangeLocalApi: ", list);
                    setUrlApi('');
                    setNome('')
                }
            }).catch( er =>{
                console.log( er)
            });
            if( !caminho) setCaminho('wrapper.dado.result');
        }
        setInterno(e.target.checked);
    }

    const onChangeSelectApi = (e) => {        
        const item = apiLocal.find(api => api.value === e.target.value);
        if( item ){
            setNome(item.nome);
            setUrlApi(e.target.value);
        }else{
            setNome(e.target.value);
            setUrlApi(e.target.value);
        }
    }

    const handleIdentificarApi = () => {
        var localUrl = urlApi;
        if( urlApi.includes('${')){
            let pos = urlApi.indexOf('${');
            let pos2 = urlApi.indexOf('}');
            const parm = urlApi.substring(pos+2, pos2);
            const userChoice = prompt("Indique o valor da variavel "+parm+": ");
            localUrl = urlApi.substring(0, pos)+userChoice;
        }
        const dado = {
            urlApi: localUrl,
            caminho: caminho
        }

        Service.POST("/api/security/model/geraCabecalhoAPI", dado).then(r => {
            console.log(r);
            if (r.success) {
                const d = r.dado;
                // if (d.success) {
                let jsonData = null;
                if (typeof d === 'object') {
                    jsonData = d; //JSON.parse(d);
                } else {
                    jsonData = JSON.parse(d);
                }
                if (Array.isArray(jsonData)) {
                    const todasAsChaves = [...new Set(jsonData.flatMap(obj => Object.keys(obj)))];
                    montarChaves(todasAsChaves);
                } else {
                    const todasAsChaves = [];
                    for (let x in jsonData) {
                        todasAsChaves.push(x);
                    }
                    montarChaves(todasAsChaves);
                }
            } else {
                setheaderTabel([]);
                alert(r.msg);
            }

        })
    }

    function montarChaves(chaves) {
        let arrayM = [];
        for (let x in chaves) {
            const chav = chaves[x];
            arrayM.push({
                key: chav,
                tipo: "String",
                nome: chav,
                mostrar: chav !== '_id'
            })
        }
        console.log('chaves :', arrayM);
        setheaderTabel(arrayM)
    }
    const onChangeHeader = (value, item, campo) => {
        setheaderTabel(prevHeader =>
            prevHeader.map(headerItem =>
                headerItem === item
                    ? { ...headerItem, [campo]: value }
                    : headerItem
            )
        );
    }

    const handleNovaColuna = () => {
        setheaderTabel(prevState => [
            ...prevState,
            {
                key: '',
                tipo: "String",
                nome: '',
                mostrar: true
            }
        ]);
    }
    const handleSeeAPI = () => {
        console.log('>>handleSeeAPI<<')
        if (!urlApi || urlApi.length == 0) return;
        var localUrl = urlApi;
        if (bannerOpen) {
            closeBanner();
            return;
        }
        if( urlApi.includes('${')){
            let pos = urlApi.indexOf('${');
            let pos2 = urlApi.indexOf('}');
            const parm = urlApi.substring(pos+2, pos2);
            const userChoice = prompt("Indique o valor da variavel "+parm+": ");
            localUrl = urlApi.substring(0, pos)+userChoice;
        }
        const dado = {
            urlApi: localUrl,
        }
        if( interno){
            if( uri && uri.length > 0){                
                dado.urlApi += "?"+uri;
            }
        }
        

        console.log( dado );

        Service.POST("/api/security/model/geraCabecalhoAPI", dado).then(r => {
            console.log(r);
            if (r.success) {
                const jsonString = JSON.stringify(r.dado, null, 2);
                setJsonTxt(jsonString);
            }else{
                setOpenSnack(true);
                setMsg(r.msg)
            }
        }).catch( er =>{
            console.log( er );
            if( er.status === 401){
                localStorage.setItem("localStorage", location.pathname);
                navigate("/login");
            }
        })
        setBannerOpen(true)
    }

    return (
        <Dialog
            onClose={handleClose}
            open={open}
            fullWidth
            maxWidth='md'
        >
            <DialogTitle>
                <Stack direction="row" spacing={1}>
                    <Typography variant='body'>
                        API
                    </Typography>
                    <FormControlLabel
                        sx={{ mt: 1 }}
                        control={
                            <Switch
                                checked={interno}
                                onChange={onChangeLocalApi}
                            />
                        }
                        label="Interno"
                    />
                    {!interno && <TextField
                        label="API"
                        size='small'
                        fullWidth
                        // variant="outlined"
                        value={urlApi || ""}
                        onChange={(e) => setUrlApi(e.target.value)}
                        slotProps={{
                            input: {
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            edge="end"
                                            color={urlApi && urlApi.length > 0 ? 'primary' : 'inherit'}
                                            onClick={handleSeeAPI}
                                        >
                                            <Visibility />
                                        </IconButton>
                                    </InputAdornment>
                                )
                            },
                        }}
                    />}
                    {interno &&
                        <Stack direction="row">
                            <FormControl fullWidth sx={{ mt: 2, minWidth: 120, width:"300px" }}
                                size='small'
                            >
                                <InputLabel htmlFor="API">API</InputLabel>
                                <Select
                                    size='small'
                                    value={urlApi}
                                    onChange={onChangeSelectApi}
                                    label="API"
                                    inputProps={{
                                        name: 'API',
                                        id: 'API',
                                    }}
                                >                                    
                                    <MenuItem value={"/api/bpmn/buscaProcessoBGPorId/${id}"}>Processo BackGround por Id</MenuItem>
                                    {apiLocal && apiLocal.map((item, index) =>
                                        <MenuItem key={index + 's-' + item.nome} value={item.value}>{item.nome}</MenuItem>
                                    )}
                                </Select>

                            </FormControl>
                            <TextField sx={{mt:2, ml:1}}
                                label="Query parameter:"
                                size='small' autoComplete="off"
                                // variant="outlined"
                                value={uri || ""}
                                onChange={(e) => setURI(e.target.value)}                                
                            />
                            <IconButton
                                aria-label="toggle password visibility"
                                edge="end"
                                color={urlApi && urlApi.length > 0 ? 'primary' : 'inherit'}
                                onClick={handleSeeAPI}
                            >
                                <Visibility />
                            </IconButton>
                        </Stack>
                    }
                </Stack>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={0} >


                    <Grid size={12}>
                        <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
                            <TextField
                                label="Caminho dos dados"
                                size='small'
                                fullWidth value={caminho || ''} onChange={(e) => setCaminho(e.target.value)}
                                helperText="Noção JavaScript: campo.arr[0].nome"
                            />

                            <FormControl sx={{ m: 1, minWidth: 220 }} size="small">
                                <InputLabel id="tp_pagina_lb">Tipo da pagina</InputLabel>
                                <Select
                                    labelId="tp_pagina_lb"
                                    id="tp_pagina"
                                    value={page}
                                    label="Pagina"
                                    onChange={(e) => setPage(e.target.value)}
                                >
                                    <MenuItem value='table'>Tabela</MenuItem>
                                    <MenuItem value='accordion'>Accordion</MenuItem>
                                    <MenuItem value='fields'>Campos</MenuItem>
                                    <MenuItem value='card'>Cards</MenuItem>
                                </Select>
                            </FormControl>
                        </Stack>
                    </Grid>

                    <Grid size={12}>
                        <FormControl>
                            <FormLabel id="demo-row-radio-buttons-group-label">Paginação</FormLabel>
                            <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="paginacao"
                                value={value}
                                onChange={handleChange}
                            >
                                <FormControlLabel value="sem" control={<Radio />} label="Sem paginação" />
                                <FormControlLabel value="front" control={<Radio />} label="Papinação no front" />
                                <FormControlLabel value="back" control={<Radio />} label="Paginação no back" />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    <Grid size={12} sx={{ fontSize: '12px' }}>
                        <p>Opção da paginação</p>
                        <ul>
                            <li><b>Sem paginação</b> Ideal para tabelas inferiores a 100 registros</li>
                            <li><b>Paginação no front</b> Ideal para quantidade media de registros maior do que 100 porem não superior a 10.000 registros. Ideal analisar o tempo de busca para não deixar ultrapassa 300ms</li>
                            <li><b>Paginação back</b> Ideal para grande quantidade de dados</li>
                        </ul>
                    </Grid>
                    <Grid size={1}>
                        <Button
                            fullWidth
                            variant="contained"
                            onClick={handleNovaColuna}
                        >Novo</Button>
                    </Grid>
                    <Grid size={8}></Grid>
                    <Grid size={3}>
                        <Button
                            fullWidth
                            variant="contained"
                            onClick={handleIdentificarApi}
                        >Gerar Cabeçalho</Button>
                    </Grid>
                    <Grid size={12}>
                        <Box sx={{mt:2}}></Box>
                    </Grid>
                    {headerTabel && headerTabel.map((item, index) =>
                        <React.Fragment key={index}>
                            <Grid size={3}>
                                <TextField
                                    id="key_id"
                                    name="key"
                                    label="Key"
                                    size='small'
                                    fullWidth
                                    variant="outlined"
                                    value={item.key || ""}
                                    onChange={(e) => onChangeHeader(e.target.value, item, 'key')}
                                />
                            </Grid>
                            <Grid size={5}>
                                <TextField
                                    id="nome_id"
                                    name="nome"
                                    label="nome"
                                    size='small'
                                    fullWidth
                                    variant="outlined"
                                    value={item.nome || ""}
                                    onChange={(e) => onChangeHeader(e.target.value, item, 'nome')}
                                />
                            </Grid>
                            <Grid size={2}>
                                {/* <TextField
                                    id="tipo_id"
                                    name="tipo"
                                    label="tipo"
                                    fullWidth
                                    variant="outlined"
                                    value={item.tipo || ""}
                                    disabled
                                    onChange={(e) => onChangeHeader(e.target.value, item, 'tipo')}
                                /> */}
                                <FormControl
                                    fullWidth
                                    size='small'
                                    sx={{ mb: 1, mt: 1 }}
                                >
                                    <InputLabel id="demo-simple-select-label">Tipo</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={item.tipo || ""}
                                        label="BookMark"
                                        onChange={(e) => onChangeHeader(e.target.value, item, 'tipo')}
                                    // onChange={handleChangeBookMarkSelect}
                                    >
                                        {listTipo.map((item, index) => (
                                            <MenuItem
                                                key={`${item}_item_${index}`}
                                                value={item}
                                            >{item}</MenuItem>
                                        ))}
                                        {/* <MenuItem value={10}>Ten</MenuItem>
                                                            <MenuItem value={20}>Twenty</MenuItem>
                                                            <MenuItem value={30}>Thirty</MenuItem> */}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid size={2}>
                                <FormControlLabel
                                    sx={{ mt: 1 }}
                                    control={
                                        <Switch
                                            checked={item?.mostrar || false}
                                            onChange={(e) => onChangeHeader(e.target.checked, item, 'mostrar')}
                                        />
                                    }
                                    label="Habilitar"
                                />
                            </Grid>
                        </React.Fragment>
                    )}
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancelar</Button>
                <Button
                    onClick={geraPagina}
                    disabled={(!headerTabel || headerTabel.length === 0) ? true : false}
                >Criar</Button>
            </DialogActions>

            <TrapFocus open disableAutoFocus disableEnforceFocus>
                <Fade appear={false} in={bannerOpen}>
                    <Paper
                        role="dialog"
                        aria-modal="false"
                        aria-label="Cookie banner"
                        square
                        variant="outlined"
                        tabIndex={-1}
                        sx={{
                            position: 'fixed',
                            top: 0,
                            bottom: 0,
                            left: "80%",
                            right: 0,
                            m: 0,
                            p: 2,
                            borderWidth: 0,
                            borderTopWidth: 1,
                            overflow: 'auto'
                        }}
                    >
                        <pre style={{
                            fontFamily: "cursive",
                            fontStyle: "italic",
                            fontSize: "12px"
                        }}>
                            {jsonTxt}
                        </pre>
                    </Paper>
                </Fade>
            </TrapFocus>
            <Snackbar open={openSnack} autoHideDuration={6000} onClose={handleCloseSnack}>
                <Alert
                    onClose={handleCloseSnack}
                    severity="success"
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {msg}
                </Alert>
            </Snackbar>
        </Dialog>
    );
}